import React from 'react'
import styles from './ColorProgressBar.module.scss'

const ColorProgressBar = ({
  selectedStatusId,
  statuses,
  statusHistory = [],
}) => {
  const lineLength = 100
  const selectedStatus = statuses.find(
    (status) => status.id === selectedStatusId,
  )
  const newRequestStatus = statuses.find((status) => status.id === 2)

  if (statusHistory.length === 0 && newRequestStatus) {
    statusHistory.push(newRequestStatus)
  }

  if (
    selectedStatus &&
    !statusHistory.find((status) => status.id === selectedStatus.id)
  ) {
    statusHistory.push(selectedStatus)
  }

  const sortedHistory = [...statusHistory].sort(
    (a, b) => a?.position - b?.position,
  )
  const filteredHistory = sortedHistory.filter(
    (status) => status?.position <= selectedStatus?.position,
  )

  const colors = filteredHistory.map((status, index) => {
    const width = lineLength / filteredHistory.length
    const offset = width * index

    return {
      color: status.color.body_color,
      width: `${width}%`,
      offset: `${offset}%`,
    }
  })

  return (
    <div className={styles.lineContainer}>
      <div className={styles.line}>
        {colors.map((color, index) => (
          <div
            key={index}
            className={`${styles.color} ${index === 0 ? styles.firstEl : ''} ${
              index === colors.length - 1 ? styles.lastEl : ''
            }`}
            style={{
              width: color.width,
              left: color.offset,
              backgroundColor: color.color,
            }}
          >
            {index < colors.length - 1 && <div className={styles.fill}></div>}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ColorProgressBar
